
import { Routing } from "lib/Routing";
import { AppContextStore } from "features/application-context/AppContextStore";

//tslint:disable-next-line: no-unused-variable
class FeedListActivator {
    //tslint:disable-next-line: no-unused-variable
    private static _instance = new FeedListActivator();

    private constructor() {
        Routing.instance.onChange(route => {
            if (Routing.instance.matches("@*/feeds/-")) {
                setTimeout(async () => {
                    const searchElement = document.createElement("feed-list");

                    const query = route.parameters.query || "";
                    if (searchElement.getAttribute("query") !== query || query === "")
                        searchElement.setAttribute("query", query);

                    await AppContextStore.instance.present("", searchElement, "Feeds", query ? `Matching ${query}` : "All feeds");
                });
            }
        });
    }
}
